import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Routes } from '@angular/router';
import { DataService } from 'src/app/_services/data.service';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-get-company-on-start',
  templateUrl: './get-company-on-start.component.html',
  styleUrls: ['./get-company-on-start.component.css']
})
export class GetCompanyOnStartComponent implements OnInit {
  compId: string;
  company: any;
  lang: 'he';
  writeDirection: string = 'rtl';
  langClass: string = '';
  showLangButtons: boolean = false;
  colorList: any = {};
  counter: number;

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private router: Router
  ) { }

  ngOnInit(): void {
            // show language
            if (this.route.snapshot.queryParams.lang === 'en') {
              this.translate.use('en');
              this.writeDirection = "ltr";
              this.langClass = "ltr-lang";
              this.translateLocal('en');
            }
            this.compId = this.route.snapshot.firstChild.params.id;
            // this.compId = this.route.snapshot.paramMap.get('id');
            if(this.compId){
            this.dataService.getSpecComp(this.compId).subscribe(specificComp => {
              console.log("initial", specificComp)
              this.dataService.currentCompany(specificComp);
              this.company = specificComp[0];
              if (this.company !== undefined) {
                if(this.counter !== 1){
                  this.counter = 0;
                }
                if(this.counter === 0 && this.company.googleAnalyticsId){
                  this.loadScript(this.company.googleAnalyticsId);
                  this.counter = 1;
                }
                if (this.route.snapshot.queryParams.lang){
                  this.company.lang = this.route.snapshot.queryParams.lang;
                }
                if (this.company.lang !== undefined) {
                  if(this.company.lang === ""){
                    this.company.lang = 'he';
                  }
                  if (this.company.lang.length > 0) {
                    this.updateLanguage(this.company.lang);
                  }
                } else if (this.company.lang === undefined || this.company.lang === "") {
                  this.company.lang = 'he';
                  this.updateLanguage(this.company.lang);
                }
                if (this.company !== undefined && this.colorList) {
                  this.colorList = this.company.colorList;
                  this.setCompanyColor(this.colorList);
                }
              } 
            });
          }
  }

  loadScript(googleAnalyticsId) {
    let node = document.createElement('script'); // creates the script tag

    // node.src = 'dfsfsf'; // sets the source (insert url in between quotes)
    // node.type = 'text/javascript'; // set the script type 
    // node.async = true; // makes script run asynchronously
    // node.charset = 'utf-8';
    node.text = 'window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag("js", new Date());gtag("config",' + '"' + googleAnalyticsId + '"' + ');'
    // append to head of document
    document.getElementsByTagName('head')[0].appendChild(node); 
  }
  
  setCompanyColor(colorList) {
    // set company color
    // document.documentElement.style.setProperty('--primary-color', colorList.primary);
    for (let k in colorList) {
      document.documentElement.style.setProperty(k, colorList[k]);
    }
  }
  translateLocal(curLang) {
    this.translate.use(curLang);
    this.updateLanguage(curLang);
  }
  updateLanguage(curLang?): void {
    if (curLang.length > 0) {
      this.company.lang = curLang;
    }
    if (this.company.showLangSwitcher) {
      this.showLangButtons = this.company.showLangSwitcher;
    }
    if (this.company.lang) {
      this.lang = this.company.lang;
      if(this.company.lang === 'en') {
        this.translate.use('en');
        this.writeDirection = "ltr";
        this.langClass = "ltr-lang";
      } else if (this.lang === "he" || this.lang === "ar") {
        this.writeDirection = "rtl"
        this.langClass = ""
      } else if(this.lang === "he" || this.lang === ""){
        this.translate.use('he');
        this.lang = "he";
        this.writeDirection = "rtl";
      }
    } 
    this.translate.use(curLang);
    document.documentElement.lang = this.lang;
    document.documentElement.dir = this.writeDirection;
    document.documentElement.classList.value = this.langClass;
  }

}
